import React, {useEffect, useState} from "react";
import "./OnlineAddress.scss";
import {ChangeDefaultAddress, GetBasket, StoreOnlineAddress} from "./OnlineAddressService";
import {ConvertToJalali} from "../../Pages/StoreDetail/StoreDetailServices";
import Rodal from "rodal";
import {useHistory} from "react-router-dom";






function OnlineAddress({list,set_selectedAddress,merchantId}) {
    //hooks
    const history = useHistory();

    const [address,set_address] = useState([]);
    const [defaultAddress,set_defaultAddress] = useState({});
    const [showModal,setShowModal] = useState(false);

    useEffect(()=>{
        console.log("VVVVVVVVVVVVVVVVV : ",merchantId)
    getAddress()
    },[])

    const getAddress = async () =>{
        const response = await StoreOnlineAddress();
        // console.log("Add : ",response);
        set_address(response.data);
        Basket()
    }

    useEffect(()=>{
        console.log("deeeeeeeeeeeeeeeeee : ",defaultAddress)
        set_selectedAddress(defaultAddress)
    },[defaultAddress])

    const AddressClick = () =>{
        setShowModal(true)
    }

    const Basket = async ()=>{
        const response = await GetBasket(merchantId)
        // console.log("basket : ",response.data)
        if(response.data.address){
            set_defaultAddress(response.data.address)
        }else {
            set_defaultAddress({uid:-1})
        }
    }

    const changeDefaultAddress = async (item)=>{
        set_defaultAddress(item);
        console.log("change default address : ",item)
        let response = await ChangeDefaultAddress(item.uid,merchantId)
        setShowModal(false)
        // console.log(response)
    }

    return(
        <div className="address-bar-container">
            <Rodal
                customStyles={{ height: 'auto', bottom: 'auto', top: '50%', transform: 'translateY(-50%)',width:'300px'}}
                animation={"zoom"} visible={showModal} onClose={()=>setShowModal(false)}>
                <div className="header-title">
                    <span>آدرس تحویل سفارش خود را انتخاب نمایید</span>
                </div>
                <div className="online-address-list">
                    {address.map(item=>{
                        return(
                            <div className="online-address-item"  onClick={()=>{
                                changeDefaultAddress(item)
                            }}>
                                <div className="info-sec">
                                    <span className="name">{item?.address?.substr(0,2001)}</span>
                                    <span className="address">{item?.province?.title+"-"+item?.city?.title}</span>
                                </div>
                                <div className="input-cont">
                                    <input
                                        type="radio" name="address" id="" checked={defaultAddress?.uid===item?.uid}/>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="add-address-btn-container">
                    <div className="add-address-btn" onClick={()=>{
                        console.log("nn",merchantId)
                        history.push("/online-store-address",{merchantId:merchantId})
                    }}>
                        <span>افزودن آدرس </span>
                        <i className="fa fa-plus"></i>
                    </div>
                </div>
            </Rodal>
            <div className="online-address-bar" onClick={AddressClick}>
                                <i className="fa fa-map-marker"></i>
                                <span>{defaultAddress.address?defaultAddress.address:" ثبت آدرس "}</span>
                                {/*<i className="fa fa-angle-left"></i>*/}
            </div>
        </div>
    )

}

export {OnlineAddress};
